import { render, staticRenderFns } from "./SupplierFoods.vue?vue&type=template&id=272f62a9&"
import script from "./SupplierFoods.vue?vue&type=script&lang=js&"
export * from "./SupplierFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports